module.exports = __webpack_public_path__ + "img/photo_campus.386a61c.JPG";